import { Injectable } from '@angular/core';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { AuthService } from '../modules/auth/services/auth.service';
import { environment } from 'src/environments/environment';
import { ToastrsService } from '../modules/dash/services/toater.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  environment = environment;

  constructor(
    private authService: AuthService,
    private toastrsService: ToastrsService
  ) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const data = JSON.parse(localStorage.getItem('dash_data') as any);

    req = req.clone({
      headers: req.headers.set('App', environment.projectName.toLocaleLowerCase())
    });

    if (data?.token) {
      req = req.clone({
        headers: req.headers.set('Authorization', `Bearer ${data.token}`)
      });
    }

    return next.handle(req).pipe(
      tap((event: HttpEvent<any>) => {
        if (!(event instanceof HttpResponse)) {
          return;
        }

        if (event.body?.status === false) {
          this.toastrsService.Showerror(this.getMessage(event.body?.message));
        }

        if (event.body?.statusCode === 401) {
          this.authService.logout();
        }
      }),
      catchError((error: HttpErrorResponse) => {
        this.toastrsService.Showerror(this.getMessage(error.error?.message));

        if (error.status === 401) {
          this.authService.logout();
        }

        return throwError(() => error);
      })
    );
  }

  private getMessage(message: unknown): string {
    return typeof message === 'string' && message.trim()
      ? message.trim()
      : 'An unexpected error occurred. Please try again.';
  }
}
